import { sortByField } from './sortByField';
import { getDate } from './getDate';

export function sortWidgets(widgets) {
  return sortByField(widgets,
    [
      widget => getDate(widget.publishDate),
      widget => getDate(widget.saveDate),
    ]);
}